/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/ViewManager/Select
 * @desc Select for ExperimentWorkflow Table Manager
 */

import type { ExperimentWorkflowTableViewOptionsProps } from 'labstep-web/components/ExperimentWorkflow/ViewManager/types';
import { ParamsContext } from 'labstep-web/contexts/params';
import { Select } from 'labstep-web/core/Select';
import { ParamsHOC } from 'labstep-web/hoc/Params';
import type React from 'react';
import styles from './styles.module.scss';
import type { ExperimentWorkflowIndexViewTypeManagerSelectProps } from './types';

export const ExperimentWorkflowViewManagerSelect: React.FC<
  ExperimentWorkflowIndexViewTypeManagerSelectProps
> = ({ value, options, onChange }) => (
  <ParamsHOC historyAction="replace">
    <ParamsContext.Consumer>
      {({ setParams }) => (
        <div
          className={styles.toggleAction}
          data-testid="experiment-workflow-view-manager"
        >
          <Select
            menuPortalTarget={document.body}
            isSearchable={false}
            options={options}
            value={value}
            onChange={(
              option: ExperimentWorkflowTableViewOptionsProps,
            ) => {
              if (option.value === 'timeline') {
                setParams({ is_ended: false });
              }
              onChange(option.value);
            }}
          />
        </div>
      )}
    </ParamsContext.Consumer>
  </ParamsHOC>
);
